// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Link from 'components/Link/Link'
import { loop } from 'utilities/objects'

// Redux:
import { closeSearch } from 'actions/search'

class SearchResultsOther extends React.Component {
	handleResultClick = () => {
		const { dispatch } = this.props

		dispatch( closeSearch() )
	}

	renderResult = ( key, item, mostRelevant = false ) => {
		return (
			<Link to={ item.url } className="-item" key={ key } onClick={ this.handleResultClick }>
				<div className="-inner">
					<div className="-text">
						<h3 dangerouslySetInnerHTML={ { __html: item.title } } />
					</div>
				</div>
			</Link>
		)
	}

	render() {
		const { translate, searchResults } = this.props

		const types = {
			pages: {
				type: 'page',
				title: 'Pages',
			},
			honours: {
				type: 'honour',
				title: 'Honours',
			},
			activities: {
				type: 'activity',
				title: 'Activities',
			}
		}

		let markup = loop( types, ( key, item ) => {
			let itemsMarkup = loop( searchResults[ key ], this.renderResult )

			if ( ! itemsMarkup ) {
				return null
			}

			return (
				<div className="-other-results-wrap" key={ key }>
					<div className="-other-results">
						<h2>{ item.title }</h2>

						{ itemsMarkup }
					</div>
				</div>
			)
		} )

		if ( searchResults.most_relevant ) {
			markup.unshift(
				<div className="-other-results-wrap -most-relevant" key="most_relevant">
					<div className="-other-results">
						<h2>Top result</h2>

						{ this.renderResult( 'most_relevant', searchResults.most_relevant, true ) }
					</div>
				</div>
			)
		}

		markup = markup.filter( Boolean )

		return markup
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		searchResults: state.search.searchResults
	}
}

export default connect( mapStateToProps )( SearchResultsOther )



// WEBPACK FOOTER //
// ./components/Search/SearchResultsOther.jsx